import { useTranslation } from 'react-i18next';
import { Button, Typography } from '../../../../../../components/MuiGenerals';
import { ReactComponent as FilterIcon } from '../../../../../../assets/icons/filter.svg';
import { ReactComponent as ArrowDonwCircle } from '../../../../../../assets/icons/ArrowDownCircle.svg'

interface IProps {
  isCollapse?: boolean;
  onClick?: () => void;
}

const ToggleFilterButton = (props: IProps) => {
  const { isCollapse, onClick } = props;

  const { t } = useTranslation('menu');

  return (
    <Button
      variant="outlined"
      onClick={onClick}
      startIcon={<FilterIcon />}
    >
      <Typography
        variant='button'
        sx={(theme) => ({
          color: theme.palette.primary.main,
          marginRight: '30px'
        })}
      >{t('filter')}
      </Typography>
      <ArrowDonwCircle
        style={{
          width: '12px',
          height: '12px',
          transform: isCollapse ? 'rotate(270deg)' : 'rotate(0deg)'
        }}
      />
    </Button>
  );
};

export default ToggleFilterButton;
